import { connect } from 'react-redux';
import ShareWishlistModal from '../../components/ShareWishlistModal';

import { toggleModal } from '../slices/shareWishlistModalSlice';

const mapState = (state) => ({
  isModalOpen: state.shareWishlistModal.isModalOpen,
});

const mapDispatch = (dispatch) => ({
  toggleModal: () => {
    const action = toggleModal();
    dispatch(action);
  },
});

export default connect(mapState, mapDispatch)(ShareWishlistModal);
